module.exports = __webpack_public_path__ + "img/bg-line-1-tablet.ee79a8a5.png";